import { entryStatusConstants } from 'tods-competition-factory';

export const playerStatus = {
  DIRECT_ACCEPTANCE: { name: 'Direct Acceptance', abbrv: 'DA', key: entryStatusConstants.DIRECT_ACCEPTANCE },
  SPECIAL_EXEMPT: { name: 'Special exempt', abbrv: 'SE', key: entryStatusConstants.SPECIAL_EXEMPT },
  JUNIOR_EXEMPT: { name: 'Junior exempt', abbrv: 'JE', key: entryStatusConstants.JUNIOR_EXEMPT },
  WILDCARD: { name: 'Wildcard', abbrv: 'WC', key: entryStatusConstants.WILDCARD },
  ALTERNATE: { name: 'Alternate', abbrv: 'ALT', key: entryStatusConstants.ALTERNATE },
  QUALIFIER: { name: 'Qualifier', abbrv: 'Q', key: entryStatusConstants.QUALIFIER },
};

export const playerStatusSort = {
  [playerStatus.DIRECT_ACCEPTANCE.abbrv]: 1,
  [playerStatus.SPECIAL_EXEMPT.abbrv]: 2,
  [playerStatus.JUNIOR_EXEMPT.abbrv]: 3,
  [playerStatus.WILDCARD.abbrv]: 4,
  [playerStatus.ALTERNATE.abbrv]: 5,
  [playerStatus.QUALIFIER.abbrv]: 6,
};
